import React, { useState } from "react";

import { ColorRedBase } from "ds/Core";

import { StyledAvatar } from "./Styles";
import { AvatarProps, AvatarSizes } from "./types";

const Avatar = ({ label, size = AvatarSizes.MEDIUM, color = ColorRedBase, url, showLabel, ...props }: AvatarProps) => {
  const cutLabel = (label || "Undefined").substring(0, 1);

  const [localURL, setLocalURL] = useState<string | undefined>(url);

  const onError = () => setLocalURL(undefined);

  return (
    <StyledAvatar title={showLabel ? label : undefined} size={size} color={color} url={localURL} {...props}>
      {/* hack to handle catch googleusercontent throwing 429 too many requests */}
      {url && <img src={url} referrerPolicy="no-referrer" onError={onError} style={{ display: "none" }} />}
      {!localURL && <span>{cutLabel}</span>}
    </StyledAvatar>
  );
};

// Ensures we re-mount the component when the url changes
// This prevents profile pictures from being cached
// in local state and not updating when the url changes
const AvatarWrapper = (props: AvatarProps) => {
  return <Avatar key={props.url} {...props} />;
};

AvatarWrapper.displayName = "Avatar";

export { AvatarWrapper as Avatar };
